module.exports = __webpack_public_path__ + "img/user-01.a8479cb8.jpg";